export default {
      id: "ic-misc-notifications-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-notifications-usage",
      toString: function () {
        return this.url;
      }
    }